import styled from 'styled-components';

export const StatusButtonsWrapper = styled.div`
    margin-left: auto;
    display: flex;
    gap: 10px;
`;
